<template>
  <app-content class="h-panel">
    <div class="h-panel-bar">
      <span class="h-panel-title">
        <template v-if="subject">{{subject.name}}</template>
        <template v-if="subject && subject.unit">(单位:{{subject.unit}})</template> - 明细账
      </span>
    </div>
    <div class="margin-right-left margin-top">
      <account-period-selector
          @confirm="handleConfirm"
          @date-change="handleDateChange"
          :current-subject="subject"
          :subject-list="subjectList"
      />
      <div class="float-right">
        <Button @click="exportExcel">导出</Button>
      </div>
    </div>
    <Row class="h-panel-body" type="flex" :space-x="10">
      <Cell :flex="1" style="overflow-x: auto;">
        <!-- 外部滚动容器：保留原有样式，仅添加position: relative -->
        <div style="max-height: 670px; overflow-y: auto; position: relative;">
          <!-- 普通表格（无数量金额） -->
          <div class="table-container" v-if="!showNumPrice">
            <!-- 表头：添加sticky固定，保留原有所有样式 -->
            <table class="cus-table" style="position: sticky; top: 0; z-index: 10;">
              <thead class="header">
              <tr>
                <td width="100">日期</td>
                <td width="100">凭证字号</td>
                <td width="150">科目</td>
                <td width="200">摘要</td>
                <td width="100" class="text-right">借方</td>
                <td width="100" class="text-right">贷方</td>
                <td width="80" class="text-center">方向</td>
                <td width="120" class="text-right">余额</td>
              </tr>
              </thead>
            </table>
            <!-- 内容表格：保留原有所有样式，仅分离表头 -->
            <table class="cus-table">
              <tbody>
              <tr v-for="(item,i) in datalist" :key="item.subjecId"  @click="onClick(i)" :class="{ selected: selectedRow === i }">
                <td width="100">{{item.voucherDate}}</td>
                <td width="100">
                  <router-link v-if="item.voucherId" :to="{name:'VoucherForm',params:{voucherId:item.voucherId}}">{{item.word}}-{{item.code}}</router-link>
                </td>
                <td width="150">{{item.subjectName}}</td>
                <td width="200">{{item.summary}}</td>
                <td width="100" class="text-right">{{item.debitAmount|numFormat}}</td>
                <td width="100" class="text-right">{{item.creditAmount|numFormat}}</td>
                <td width="80" class="text-center">{{item.balanceDirection}}</td>
                <td width="120" class="text-right">{{item.balance|numFormat}}</td>
              </tr>
              <tr v-if="!datalist.length">
                <td colspan="8" class="text-center padding">暂无数据</td>
              </tr>
              </tbody>
            </table>
          </div>

          <!-- 数量金额表格 -->
          <div class="table-container" v-else>
            <!-- 表头：添加sticky固定，保留原有所有样式 -->
            <table class="cus-table" style="width: 1550px; position: sticky; top: 0; z-index: 10;">
              <thead class="header">
              <tr>
                <td rowspan="2" width="100">日期</td>
                <td rowspan="2" width="100">凭证字号</td>
                <td rowspan="2" width="150">科目</td>
                <td rowspan="2" width="200">摘要</td>
                <td colspan="3">借方发生额</td>
                <td colspan="3">贷方发生额</td>
                <td colspan="4">余额</td>
              </tr>
              <tr>
                <td width="100" class="text-right">数量</td>
                <td width="100" class="text-right">单价</td>
                <td width="100" class="text-right">金额</td>
                <td width="100" class="text-right">数量</td>
                <td width="100" class="text-right">单价</td>
                <td width="100" class="text-right">金额</td>
                <td width="80" class="text-center">方向</td>
                <td width="100" class="text-right">数量</td>
                <td width="100" class="text-right">单价</td>
                <td width="120" class="text-right">金额</td>
              </tr>
              </thead>
            </table>
            <!-- 内容表格：保留原有所有样式，仅分离表头 -->
            <table class="cus-table" style="width: 1550px;">
              <tbody>
              <tr v-for="item in datalist" :key="item.subjecId">
                <td width="100">{{item.voucherDate}}</td>
                <td width="100">
                  <router-link v-if="item.voucherId" :to="{name:'VoucherForm',params:{voucherId:item.voucherId}}">{{item.word}}-{{item.code}}</router-link>
                </td>
                <td width="150" class="nowrap">{{item.subjectName}}</td>
                <td width="200" class="nowrap">{{item.summary}}</td>
                <td width="100" class="text-right">{{item.debitAmount&&item.balanceDirection=='借'?item.num:''}}</td>
                <td width="100" class="text-right">{{item.debitAmount&&item.balanceDirection=='借'?item.price:''}}</td>
                <td width="100" class="text-right">{{item.debitAmount|numFormat}}</td>
                <td width="100" class="text-right">{{item.creditAmount&&item.balanceDirection=='贷'?item.num:''}}</td>
                <td width="100" class="text-right">{{item.creditAmount&&item.balanceDirection=='贷'?item.price:''}}</td>
                <td width="100" class="text-right">{{item.creditAmount|numFormat}}</td>
                <td width="80" class="text-center">{{item.balanceDirection}}</td>
                <td width="100" class="text-right">{{item.numBalance|numFormat}}</td>
                <td width="100" class="text-right">{{item.price|numFormat}}</td>
                <td width="120" class="text-right">{{item.balance|numFormat}}</td>
              </tr>
              <tr v-if="!datalist.length">
                <td colspan="14" class="text-center padding">暂无数据</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Cell>
      <Cell v-width="200">
        <Tree
            v-model="subjectId"
            @select="subjectSelect"
            :option="param"
            ref="subjectTree"
            filterable
            selectOnClick
            className="h-tree-theme-row-selected">
        </Tree>
      </Cell>
    </Row>
  </app-content>
</template>

<script>
import * as XLSX from "xlsx-js-style";

export default {
  name: 'DetailedAccounts',
  filters: {
    numFormat(val) {
      if (val === null || val === undefined || val === '') return '';
      const n = Number(val);
      return isNaN(n) ? '' : n.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
  },
  data() {
    return {
      loading: false,
      param: {
        keyName: 'id',
        parentName: 'parentId',
        titleName: 'subjectCodeName',
        dataMode: 'list',
        datas: []
      },
      datalist: [],
      subjectId: null,
      showNumPrice: false,
      numPriceDisabled: true,
      accountDate: null,
      subject: null,
      showCode: false,
      selectedRow: null,
      startDate: null,
      endDate: null,
      formattedStartDate: null,
      formattedEndDate: null,
      loadListTimer: null,
      subjectList: [],
    };
  },
  watch: {
    subject() {
      let org = this.showNumPrice;
      if (this.subject.unit) {
        this.numPriceDisabled = false;
        this.showNumPrice = true;
      } else {
        this.showNumPrice = false;
      }
      if (org == this.showNumPrice) {
        this.loadList();
      }
    },
    showNumPrice() {},
  },
  created() {
    this.loadSubject();
  },
  methods: {
    // 格式化日期为当月1号
    formatDateToFirstDay(monthStr) {
      const [year, month] = monthStr.split('-').map(Number);
      return `${year}-${String(month).padStart(2, '0')}-01`;
    },

    handleDateChange({startMonth, endMonth}) {
      if (startMonth) {
        this.formattedStartDate = this.formatDateToFirstDay(startMonth);
        const [year, month] = startMonth.split('-').map(Number);
        this.startDate = new Date(year, month - 1, 1);
      }
      if (endMonth) {
        this.formattedEndDate = this.formatDateToFirstDay(endMonth);
        const [year, month] = endMonth.split('-').map(Number);
        this.endDate = new Date(year, month - 1, 1);
      }
    },

    handleConfirm(params) {
      this.formattedStartDate = this.formatDateToFirstDay(params.startMonth);
      this.formattedEndDate = this.formatDateToFirstDay(params.endMonth);

      if (params.subject && params.subject.id) {
        this.subjectId = params.subject.id;
        this.subject = {
          id: params.subject.id,
          code: params.subject.code,
          name: params.subject.name,
          unit: params.subject.unit || '',
          ...params.subject
        };
      }
      this.loadList();
    },

    onClick(i) {
      this.selectedRow = this.selectedRow === i ? -1 : i;
    },

    async loadSubject() {
      this.datalist = [];
      const {data} = await this.$api.accountbook.loadSubject({accountDate: this.accountDate});
      const formattedData = data.map(subject => ({
        id: subject.id,
        subjectCode: subject.code,
        subjectName: subject.name,
        subjectCodeName: subject.code + " " + subject.name,
        subjectFullName: subject.subjectFullName || subject.name,
        ...subject
      }));
      this.subjectList = formattedData;
      this.$set(this.param, "datas", formattedData);
      if (formattedData.length) {
        this.subjectId = formattedData[0].id;
        this.subject = formattedData[0];
      }
    },

    loadList() {
      if (this.loadListTimer) clearTimeout(this.loadListTimer);
      this.loadListTimer = setTimeout(() => {
        this.loading = true;
        const params = {
          startDate: this.formattedStartDate,
          endDate: this.formattedEndDate,
          subjectId: this.subjectId,
          showNumPrice: this.showNumPrice,
          subjectCode: this.subject.code || '',
        };
        this.$api.accountbook.loadVoucherDetailsByDate(params).then(({data}) => {
          this.datalist = data;
        }).finally(() => {
          this.loading = false;
          this.loadListTimer = null;
        });
      }, 50);
    },

    subjectSelect(node) {
      this.subject = node;
      this.subjectId = node.id;
    },

    // 导出Excel
    exportExcel() {
      if (!this.datalist || this.datalist.length === 0) {
        this.$Message.warning("暂无明细数据，无法导出");
        return;
      }
      const title = `${this.subject.name}${this.subject.unit ? `(单位:${this.subject.unit})` : ''}明细账`;
      const sheetData = [];
      sheetData.push([title]);
      sheetData.push([]);

      // 普通明细账
      if (!this.showNumPrice) {
        sheetData.push(["日期", "凭证字号", "科目", "摘要", "借方", "贷方", "方向", "余额"]);
        this.datalist.forEach(item => {
          sheetData.push([
            item.voucherDate || "",
            item.word && item.code ? `${item.word}-${item.code}` : "",
            item.subjectName || "",
            item.summary || "",
            this.$options.filters.numFormat(item.debitAmount),
            this.$options.filters.numFormat(item.creditAmount),
            item.balanceDirection || "",
            this.$options.filters.numFormat(item.balance)
          ]);
        });
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet(sheetData);
        ws["!merges"] = [{s: {r: 0, c: 0}, e: {r: 0, c: 7}}];
        ws["!cols"] = [
          {wch: 12}, {wch: 12}, {wch: 18}, {wch: 26},
          {wch: 14}, {wch: 14}, {wch: 8}, {wch: 14}
        ];
        XLSX.utils.book_append_sheet(wb, ws, "明细账");
        XLSX.writeFile(wb, `${title}.xlsx`);
      } else {
        // 数量金额式双层表头
        sheetData.push([
          "日期", "凭证字号", "科目", "摘要",
          "借方发生额", "", "",
          "贷方发生额", "", "",
          "余额", "", "", ""
        ]);
        sheetData.push([
          "", "", "", "",
          "数量", "单价", "金额",
          "数量", "单价", "金额",
          "方向", "数量", "单价", "金额"
        ]);
        this.datalist.forEach(item => {
          const debitNum = item.debitAmount && item.balanceDirection === '借' ? this.$options.filters.numFormat(item.num) : "";
          const debitPrice = item.debitAmount && item.balanceDirection === '借' ? this.$options.filters.numFormat(item.price) : "";
          const creditNum = item.creditAmount && item.balanceDirection === '贷' ? this.$options.filters.numFormat(item.num) : "";
          const creditPrice = item.creditAmount && item.balanceDirection === '贷' ? this.$options.filters.numFormat(item.price) : "";
          sheetData.push([
            item.voucherDate || "",
            item.word && item.code ? `${item.word}-${item.code}` : "",
            item.subjectName || "",
            item.summary || "",
            debitNum,
            debitPrice,
            this.$options.filters.numFormat(item.debitAmount),
            creditNum,
            creditPrice,
            this.$options.filters.numFormat(item.creditAmount),
            item.balanceDirection || "",
            this.$options.filters.numFormat(item.numBalance),
            this.$options.filters.numFormat(item.price),
            this.$options.filters.numFormat(item.balance)
          ]);
        });
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet(sheetData);
        ws["!merges"] = [
          {s: {r: 0, c: 0}, e: {r: 0, c: 13}},
          {s: {r: 2, c: 4}, e: {r: 2, c: 6}},
          {s: {r: 2, c: 7}, e: {r: 2, c: 9}},
          {s: {r: 2, c: 10}, e: {r: 2, c: 13}},
        ];
        ws["!cols"] = [
          {wch: 12}, {wch: 12}, {wch: 18}, {wch: 26},
          {wch: 10}, {wch: 10}, {wch: 14},
          {wch: 10}, {wch: 10}, {wch: 14},
          {wch: 8}, {wch: 10}, {wch: 10}, {wch: 14}
        ];
        XLSX.utils.book_append_sheet(wb, ws, "明细账");
        XLSX.writeFile(wb, `${title}.xlsx`);
      }
      this.$Message.success("导出完成");
    }
  }
};
</script>

<style scoped lang="less">
.cus-table {
  width: 100%;
  border-collapse: collapse;
}

.cus-table td {
  border: 1px solid #e8e8e8;
  padding: 8px 8px;
}

.cus-table tr {
  background: #ffffff;
}

.cus-table tr.selected {
  background: rgba(31, 165, 227, 0.2);
}

.cus-table .header tr {
  background: #f5f7fa;
}

.table-container {
  position: relative;
  margin-bottom: 10px;
}

.cus-table tbody tr:first-child td {
  border-top: 1px solid #e8e8e8;
}

.nowrap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.text-right {
  text-align: right;
}

.text-center {
  text-align: center;
}

.padding {
  padding: 10px 0;
}
</style>